export default {
  SAVE_DATA_TABLE_ROW_EXCEL (state, data) {
    state.dataCacheTableRows = data
  },

  SAVE_DATA_ERR_ROW_EXCEL (state, data) {
    state.dataCacheErrRecordExcel = data
  },

  SAVE_DATA_FILE_NAME_EXCEL (state, data) {
    state.dataCacheFileNameExxel = data
  }
}
